import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {withFirebase} from 'react-redux-firebase';

import LocationIcon from '@material-ui/icons/Place';
import TimeIcon from '@material-ui/icons/DateRange';
import ContactIcon from '@material-ui/icons/MailOutline';
import PeopleIcon from '@material-ui/icons/PeopleOutline';
import WatchLaterIcon from '@material-ui/icons/WatchLater';

import {styles, Countdown} from '../../common';
import {SlideContainer} from '../../common/slideshow';
import {formatDescription} from '../../../util/eventHelper';
import firebaseUtils from '../../../util/FirebaseUtils';

import logo from '../../../assets/images/logo-Spiria.png';

const icons = {
    clock: WatchLaterIcon,
    contact: ContactIcon,
    location: LocationIcon,
    participants: PeopleIcon,
    time: TimeIcon
};

const getIcon = (type) => {
    return icons[type];
};

class EventSlide extends React.Component {
    constructor(props, context) {
        super(props, context);
        
        this.getImage = this.getImage.bind(this);
        this.getOptionalFields = this.getOptionalFields.bind(this);

        this.state = {
            imageUrl: null
        };
    }

    componentDidMount() {
        this.getImage();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.image !== this.props.image) {
            this.getImage();
        }
    }

    getImage() {
        firebaseUtils.getImageUrl(this.props.firebase, this.props.image)
            .then(imageUrl => this.setState({imageUrl: imageUrl ? imageUrl : logo}));
    }

    getOptionalFields(rest) {
        if (rest) {
            return Object.keys(rest)
                .reduce((acc, key) => {
                    const value = do {
                        if (!rest.timeOverride && rest[key] && key === 'time' && moment(rest[key]).isValid()) {
                            if (moment.isMoment(rest[key])) {
                                rest[key].format('LLLL');
                            } else {
                                moment(rest[key]).format('LLLL');
                            }
                        } else {
                            rest[key];
                        }
                    };
                    if ((typeof value === 'number' && value > 1) || (typeof value === 'string' && value.trim() !== '')) {
                        const Icon = getIcon(key);
                        if (Icon) {
                            acc.push(
                                <div key={key} className={`${key}`}>
                                    <Icon/>
                                    <span>{value}</span>
                                </div>
                            );
                        }
                    }
                    return acc;
                }, []);
        } else {
            return [];
        }
    }

    render() {
        const {description, fontSettings, onLoad, title, imageSettingsFields, ...rest} = this.props;

        return (
            <SlideContainer className="event" {...this.props}>
                <div className="image-wrapper">
                    <img
                        alt="event"
                        className="image"
                        onLoad={onLoad}
                        src={this.state.imageUrl}
                        style={styles.slideImage(imageSettingsFields)}
                    />
                    {do {
                        if (this.props.time && this.props.isCountdown) {
                            <Countdown time={this.props.time}/>;
                        }
                    }}
                    <div className="image-overlay"/>
                </div>
                <div className="info">
                    <div className="title" style={fontSettings ? styles.slideFont(fontSettings.title) : {}}>{title}</div>
                    <div className="description" style={fontSettings ? styles.slideFont(fontSettings.description): {}} dangerouslySetInnerHTML={{ __html: formatDescription(description) }}></div>
                    <div className="details" style={fontSettings ? styles.slideFont(fontSettings.details) : {}}>
                        {this.getOptionalFields(rest)}
                    </div>
                </div>
            </SlideContainer>
        );
    }
}

EventSlide.propTypes = {
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    fontSettings: PropTypes.object,
    image: PropTypes.string,
    imageSettingsFields: PropTypes.object,
    isCountdown: PropTypes.bool,
    location: PropTypes.string,
    onLoad: PropTypes.func,
    time: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    title: PropTypes.string,
};

export default withFirebase(EventSlide);



// WEBPACK FOOTER //
// ./src/components/dashboard/slides/EventSlide.js